import MessageType from '../../../enums/MessageType';
import Translation from '../../../v2/lang/Translation';

const messageByDeliveryId = {
  43: 'messages.kerry',
};

export default (selectedDeliveryOptionIdList, paymentType) => {
  const messageById = selectedDeliveryOptionIdList.map(deliveryOptionId => messageByDeliveryId[deliveryOptionId])
    .filter(messageArray => messageArray);
  return messageById.length > 0 ? {
    type: MessageType.INFO,
    embeddedValues: [Translation.getText(paymentType)],
    translationKey: `${messageById[0]}.${paymentType.toLowerCase()}`,
  } : null;
};
